import type { PropsWithChildren } from 'react';
import { ModalProvider } from '@banhala/ui-kit';
import { useIsFocused } from '@react-navigation/native';

/**
 * 화면이 blur 되면 모달 레이어를 감추는 `ModalProvider`(웹 전용 동작, 네이티브에서는
 * `hidden` 이 무시됨).
 *
 * 웹은 모달이 `document.body` 로 portal 되므로 react-navigation 이 비활성 화면에 거는
 * `display: none`(react-native-screens `Screen.web`)이 모달에는 닿지 않는다. 그대로 두면
 * 화면을 이동해도 이전 화면의 모달이 계속 떠 있다.
 *
 * `useIsFocused` 구독을 이 컴포넌트 안에 가둬, focus 가 바뀌어도 호출부(AnalyticsScreen /
 * screenLayout) 전체가 아니라 여기서부터만 리렌더되게 한다(children 은 prop 으로 받은
 * 동일 element 라 bail out).
 */
export const FocusAwareModalProvider = ({ children }: PropsWithChildren) => {
  const isFocused = useIsFocused();
  return <ModalProvider hidden={!isFocused}>{children}</ModalProvider>;
};